<template>
   <router-view></router-view>
</template>
<script>
export default {
  name: "employee-role",
  data() {
    return {}
  },
}
</script>
